import { getField, updateField } from 'vuex-map-fields'

import volunteer from '@/services/http/api/volunteer'
import { useChildrenFilterStore } from '@/stores/filterChildren'

const emptyVolunteerModal = () => ({
  volunteers: [],
  volunteerId: null,
  volunteerModalVisibility: false,
  selectedChildEditionId: null,
  wioStructLocationName: null,
  wioStructLocationId: null,
  volunteersLoader: false,
  sendingLoader: false
})

export default {
  namespaced: true,
  state: {
    volunteerModal: emptyVolunteerModal()
  },
  getters: {
    getVolunteerModal: (state) => state.volunteerModal,
    getVolunteerId: (state) => getField(state.volunteerModal)
  },
  mutations: {
    setVolunteerModal(state, fields) {
      Object.keys(state.volunteerModal).forEach((key) => {
        const fieldValue = fields[key]
        if (typeof fieldValue === 'undefined') return
        state.volunteerModal[key] = fieldValue
      })
    },
    updateVolunteerId(state, field) {
      updateField(state.volunteerModal, field)
    },
    clearVolunteerModal(state) {
      state.volunteerModal = emptyVolunteerModal()
    }
  },
  actions: {
    getVolunteers({ commit }, payload) {
      commit('setVolunteerModal', { volunteersLoader: true })
      return volunteer
        .getVolunteers(payload)
        .then(({ data }) => {
          const volunteersOptions = data.data.map((item) => ({
            value: item.id,
            text: item.first_name.concat(' ', item.last_name)
          }))
          commit('setVolunteerModal', { volunteers: volunteersOptions })
          return data.data
        })
        .finally(() => {
          commit('setVolunteerModal', { volunteersLoader: false })
        })
    },
    assignVolunteer({ commit, rootGetters }, payload) {
      const { routeName } = payload
      commit('setVolunteerModal', { sendingLoader: true })
      return volunteer
        .assignVolunteer(payload)
        .then(({ data }) => {
          if (routeName === 'ChildCard') {
            const { school_hydra_users: schoolHydraUsers } =
              rootGetters['childEdition/getChild'] ?? {}
            commit(
              'childEdition/setChild',
              {
                child_edition: data.data,
                school_hydra_users: schoolHydraUsers
              },
              { root: true }
            )
          }
          if (routeName === 'ChildrenList') {
            const filterChildrenStore = useChildrenFilterStore()
            filterChildrenStore.updateChildrenListItem(data.data)
          }
          commit('clearVolunteerModal')
        })
        .finally(() => {
          commit('setVolunteerModal', { sendingLoader: false })
        })
    },
    detachVolunteer({ commit, rootGetters }, payload) {
      commit('setVolunteerModal', { sendingLoader: true })
      return volunteer
        .detachVolunteer(payload)
        .then(({ data }) => {
          const { school_hydra_users: schoolHydraUsers } =
            rootGetters['childEdition/getChild'] ?? {}
          commit(
            'childEdition/setChild',
            {
              child_edition: data.data,
              school_hydra_users: schoolHydraUsers
            },
            { root: true }
          )
          commit('clearVolunteerModal')
        })
        .finally(() => {
          commit('setVolunteerModal', { sendingLoader: false })
        })
    }
  }
}
